import { gsap } from "gsap";
class GspAnimate {
    constructor() {
        this.fadeUp=document.querySelectorAll(".fadeUp");
    }

    gspFadeUp(){
        if(this.fadeUp){
            this.fadeUp.forEach(fu => {
                gsap.fromTo(fu,{
                    y:'20%',
                    autoAlpha:0,
                    
                }, {
                    duration:1,
                    y: 0,
                    autoAlpha: 1,
                    scrollTrigger: {
                        trigger: fu,
                        start: "top bottom",
                    }
                })
            });
        }
    }
}
export default GspAnimate